import { render, staticRenderFns } from "./TableProductAddComponent.vue?vue&type=template&id=05c455a4"
import script from "./TableProductAddComponent.vue?vue&type=script&lang=js"
export * from "./TableProductAddComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports